var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_143_47546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2055 39H22.7945C20.7022 39 19 37.2527 19 35.1051V21.8949C19 19.7472 20.7022 18 22.7945 18H34.2055C36.2978 18 38 19.7472 38 21.8948V35.1051C38 37.2527 36.2978 39 34.2055 39ZM22.7945 19.8236C21.6818 19.8236 20.7766 20.7527 20.7766 21.8948V35.1051C20.7766 36.2472 21.6818 37.1764 22.7945 37.1764H34.2055C35.3182 37.1764 36.2234 36.2472 36.2234 35.1051V21.8949C36.2234 20.7527 35.3182 19.8236 34.2055 19.8236H22.7945ZM32.9862 20.7893C31.7107 20.7893 30.6766 21.8507 30.6766 23.16C30.6762 23.5225 30.7572 23.8803 30.9133 24.2056L29.264 25.8985C29.0506 25.8117 28.8231 25.7672 28.5935 25.7673C28.3456 25.7671 28.1003 25.8189 27.8726 25.9196L26.1852 24.1876C26.3311 23.8767 26.4129 23.5282 26.4129 23.16C26.4129 21.8508 25.3789 20.7893 24.1034 20.7893C22.8279 20.7893 21.7939 21.8507 21.7939 23.16C21.7939 24.4692 22.8279 25.5306 24.1034 25.5306C24.513 25.5311 24.9152 25.4192 25.2685 25.2066L26.9179 26.8995C26.8198 27.1333 26.7693 27.3851 26.7696 27.6396C26.7696 28.4426 27.2622 29.1272 27.954 29.3932V31.57C26.9715 31.8426 26.2486 32.7635 26.2486 33.8581C26.2486 35.1673 27.2825 36.2287 28.5581 36.2287C29.8336 36.2287 30.8676 35.1674 30.8676 33.8581C30.8676 32.817 30.2134 31.9333 29.3042 31.6147V29.3644C29.9585 29.08 30.4176 28.4149 30.4176 27.6396C30.4178 27.3665 30.3596 27.0968 30.2472 26.8493L31.8379 25.2165C32.1872 25.4227 32.5832 25.5311 32.9862 25.5306C34.2617 25.5306 35.2957 24.4692 35.2957 23.16C35.2957 21.8508 34.2617 20.7893 32.9862 20.7893ZM24.1 24.0353C23.629 24.0353 23.2473 23.6434 23.2473 23.16C23.2473 22.6766 23.629 22.2847 24.1 22.2847C24.571 22.2847 24.9528 22.6766 24.9528 23.16C24.9528 23.6434 24.5709 24.0352 24.1 24.0352M29.3975 33.9064C29.3975 34.3898 29.0157 34.7817 28.5448 34.7817C28.0738 34.7817 27.692 34.3898 27.692 33.9064C27.692 33.4229 28.0738 33.0311 28.5447 33.0311C29.0157 33.0311 29.3975 33.423 29.3975 33.9064ZM32.9827 24.0352C32.5118 24.0352 32.13 23.6433 32.13 23.16C32.13 22.6765 32.5118 22.2846 32.9827 22.2846C33.4537 22.2846 33.8355 22.6765 33.8355 23.1599C33.8355 23.6433 33.4537 24.0352 32.9828 24.0352",
    fill: "#F26064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_143_47546",
    x: 0.3,
    y: 0.3,
    width: 57.4,
    height: 57.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_47546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_143_47546",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon4);
export default __webpack_public_path__ + "static/media/webIcon4.7f0b8e3b43e894ead9f110fdac5ee972.svg";
export { ForwardRef as ReactComponent };